import UsersIndexingGrid from './users-indexing-grid';

export default function UsersIndexingPage() {
  return <UsersIndexingGrid />;
}
